import React from "react";
import GenericOrdersListing from "@Pages/OrderListing/GenericOrdersListing.js";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import ChatPopup from "@Pages/GenericOrderChat/ChatPopup.jsx";
function FinancialCoordinatorPendingOrdersListing() {
  return (
    <GenericOrdersListing
      title="Pending Orders"
      isReleased={false}
      isCanceled={false}
      readOnly={false}
      icon={AssignmentRoundedIcon}
      ChatPopup={ChatPopup}
      showAddInvoice={true}
    />
  );
}

export default FinancialCoordinatorPendingOrdersListing;
